import * as React from "react";

// Interfaces
import IDoctor from "../domain/interfaces/IDoctor";

export interface IDoctorsContext {
	doctors: IDoctor[];
	handleDoctorsChange: (val: IDoctor[]) => void;
}

export const DoctorsContext = React.createContext<IDoctorsContext>({
	doctors: [],
	handleDoctorsChange: (val: IDoctor[]) => {},
});

export interface DoctorsManagerProps {
	children: React.ReactNode;
}

const DoctorsManager: React.FC<DoctorsManagerProps> = ({ children }) => {
	// States
	const [doctors, setDoctors] = React.useState<IDoctor[]>([]);

	// Handlers
	const handleDoctorsChange = React.useCallback((val: IDoctor[]) => {
		setDoctors(val);
	}, []);

	return (
		<DoctorsContext.Provider
			value={{
				doctors,
				handleDoctorsChange,
			}}
		>
			{children}
		</DoctorsContext.Provider>
	);
};

export const useDoctorsManager = () => React.useContext(DoctorsContext);

export default DoctorsManager;
